import { jsx, jsxs } from "react/jsx-runtime";
const SvgI = (props) => /* @__PURE__ */ jsxs("svg", { "data-name": "Group 20", xmlns: "http://www.w3.org/2000/svg", width: "5.25rem", height: "5.25rem", viewBox: "0 0 186.251 142.794", ...props, children: [
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "98rhbc7goa", children: /* @__PURE__ */ jsx("path", { "data-name": "Rectangle 24", d: "M0 0h186.251v142.794H0z" }) }) }),
  /* @__PURE__ */ jsxs("g", { "data-name": "Group 19", style: {
    clipPath: "url(#98rhbc7goa)"
  }, children: [
    /* @__PURE__ */ jsx("path", { "data-name": "Path 10", d: "M48.389 137.863 4.931 94.4a16.835 16.835 0 0 1 23.808-23.8L72.2 114.055a16.835 16.835 0 1 1-23.808 23.808" }),
    /* @__PURE__ */ jsx("path", { "data-name": "Path 11", d: "M181.321 28.739 72.235 137.825a16.834 16.834 0 1 1-23.808-23.807L157.513 4.931a16.835 16.835 0 0 1 23.808 23.808" })
  ] })
] });
export default SvgI;
